var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-sheet",
        {
          staticStyle: {
            position: "sticky",
            "z-index": "99997 !important",
            "padding-bottom": "16px",
            "margin-top": "28px",
          },
          style: {
            height: _vm.headHeight,
            top: _vm.headTop,
            "box-shadow": _vm.$vuetify.breakpoint.smAndDown
              ? "rgba(0, 0, 0, 0.2) 0px 8px 6px -6px"
              : "",
          },
        },
        [
          _c(
            "v-flex",
            {
              staticClass: "d-flex",
              style: {
                "flex-direction": _vm.$vuetify.breakpoint.mdAndDown
                  ? "column"
                  : "row",
                "align-items": "start",
                "white-space": "nowrap",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "flex-basis": "100%",
                    width: "100%",
                    flex: "1",
                  },
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "mr-auto result-title",
                      staticStyle: {
                        "margin-top": "0.5em",
                        "margin-bottom": "1em",
                      },
                    },
                    [
                      !_vm.$vuetify.breakpoint.mdAndDown
                        ? _c("div", {
                            staticStyle: {
                              width: "24px",
                              display: "inline-block",
                            },
                          })
                        : _c(
                            "v-icon",
                            {
                              staticStyle: {
                                transition:
                                  "transform 0.3s cubic-bezier(0.075, 0.82, 0.165, 1)",
                                "margin-right": "8px",
                              },
                              style: {
                                transform: _vm.isCollapsed
                                  ? "rotate(-90deg)"
                                  : "",
                              },
                              attrs: {
                                title: _vm.isCollapsed
                                  ? "Show actions"
                                  : "Hide actions",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isCollapsed = !_vm.isCollapsed
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$MDI.ChevronDown) +
                                  "\n                "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Top 100")]),
                      _vm._v(" "),
                      _vm.filteredTotal < _vm.entryLength
                        ? _c("small", { staticClass: "ml-2" }, [
                            _vm._v(
                              "of " +
                                _vm._s(_vm.filteredTotal) +
                                " filtered hits"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filterChips.length > 0 &&
                      !_vm.$vuetify.breakpoint.smAndDown
                        ? _c(
                            "span",
                            { staticClass: "filter-chips" },
                            [
                              _vm._l(_vm.filterChips, function (chip) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: chip.key,
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      outlined: "",
                                      close: "",
                                      color: _vm.entry.color,
                                      title: chip.text,
                                    },
                                    on: {
                                      "click:close": function ($event) {
                                        return _vm.onColumnFilter(
                                          chip.key,
                                          null
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(chip.text))]
                                )
                              }),
                              _vm._v(" "),
                              _vm.filterChips.length > 1
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { small: "" },
                                      on: { click: _vm.clearFilters },
                                    },
                                    [_vm._v("Clear all")]
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.isCollapsed || _vm.$vuetify.breakpoint.lgAndUp
                ? _c(
                    "v-flex",
                    {
                      staticClass: "d-flex",
                      staticStyle: { width: "100%" },
                      style: {
                        "flex-direction": _vm.$vuetify.breakpoint.mdAndDown
                          ? "column"
                          : "row",
                        "align-items": "center",
                        "white-space": "nowrap",
                        gap: "24px",
                        flex: _vm.$vuetify.breakpoint.mdAndDown ? "0" : "1",
                        "padding-left": _vm.$vuetify.breakpoint.mdAndDown
                          ? "24px"
                          : "",
                      },
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "d-flex",
                          staticStyle: { "flex-basis": "100%", width: "100%" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            [
                              _c(
                                "h3",
                                [
                                  _vm._v(
                                    "Filter\n                            "
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { "open-delay": "300", top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$MDI
                                                          .HelpCircleOutline
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        615052215
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Filter hits by which query residues are present in the match. Select a pattern to show only hits matching that specific subset of query residues."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("motif-filter", {
                                attrs: {
                                  items: _vm.dbGaps,
                                  value: _vm.gapFilter ? _vm.gapFilter : "",
                                  queryresidues: _vm.queryresidues,
                                  color: _vm.primaryColor,
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.gapFilter = $event
                                  },
                                  "click:clear": function ($event) {
                                    _vm.gapFilter = ""
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.smAndDown
                            ? _c(
                                "div",
                                { staticClass: "mobile-table-actions" },
                                [
                                  _c("ResultFilterMenu", {
                                    attrs: {
                                      columns: _vm.mobileFilterColumns,
                                      color: _vm.entry.color,
                                    },
                                    on: {
                                      filter: _vm.onColumnFilter,
                                      clear: _vm.clearFilters,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: { bottom: "", left: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          title: "Sort options",
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        _vm._s(_vm.$MDI.Sort)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1220363849
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        { attrs: { flat: "", dense: "" } },
                                        [
                                          _c(
                                            "v-list-item-group",
                                            {
                                              attrs: {
                                                mandatory: "",
                                                color: _vm.entry.color,
                                                value: _vm.filterKeys.indexOf(
                                                  _vm.sortKey
                                                ),
                                              },
                                            },
                                            _vm._l(
                                              _vm.filterKeys,
                                              function (key) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: key,
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.changeSortMode(
                                                          key
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnLabels[key]
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-item-icon",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            style: {
                                                              opacity:
                                                                _vm.sortKey ==
                                                                key
                                                                  ? 1
                                                                  : 0,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  _vm.sortOrder <
                                                                    0
                                                                    ? _vm.$MDI
                                                                        .ChevronDown
                                                                    : _vm.$MDI
                                                                        .ChevronUp
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasEntries
        ? _c(
            "table",
            {
              staticClass: "v-table result-table",
              staticStyle: { position: "relative", "margin-bottom": "3em" },
              style: { "--active-color": _vm.primaryColor },
            },
            [
              _c("colgroup", [
                _c("col", { staticStyle: { width: "36px" } }),
                _vm._v(" "),
                _c("col", { staticStyle: { "min-width": "12%" } }),
                _vm._v(" "),
                _vm.hasDescription
                  ? _c("col", { staticStyle: { width: "25%" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasTaxonomy
                  ? _c("col", { staticStyle: { width: "15%" } })
                  : _vm._e(),
                _vm._v(" "),
                _c("col", { staticStyle: { width: "8%" } }),
                _vm._v(" "),
                _c("col", { staticStyle: { width: "6%" } }),
                _vm._v(" "),
                _c("col", { staticStyle: { width: "6%" } }),
                _vm._v(" "),
                _c("col", { staticStyle: { "min-width": "12%" } }),
                _vm._v(" "),
                _c("col", { staticStyle: { width: "6%" } }),
              ]),
              _vm._v(" "),
              _c(
                "thead",
                {
                  staticClass: "sticky-thead",
                  staticStyle: {
                    position: "sticky",
                    "z-index": "99997 !important",
                  },
                  style: {
                    top: _vm.colheadTop,
                    "background-color": _vm.$vuetify.theme.dark
                      ? "#1e1e1e"
                      : "#fff",
                  },
                },
                [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "thin select-all-th",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "v-input--selection-controls__input select-all custom-checkbox",
                            staticStyle: {
                              "user-select": "none",
                              "-webkit-user-select": "none",
                              cursor: "pointer",
                              position: "absolute",
                              top: "calc(50% - 12px)",
                              left: "6px",
                            },
                            attrs: {
                              id: "top#select-all",
                              length: _vm.entryLength,
                              title: _vm.multipleSelectionEnabled
                                ? "click to select all the entries"
                                : "select the first entry (multiple selection is WIP)",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleSelectAll($event)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "v-icon notranslate",
                                class: {
                                  "theme--light": !_vm.$vuetify.theme.dark,
                                  "theme--dark": _vm.$vuetify.theme.dark,
                                },
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "v-icon__svg",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 24 24",
                                      role: "img",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      staticClass: "unchecked",
                                      attrs: {
                                        d: "M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      staticClass: "checked",
                                      attrs: {
                                        d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      staticClass: "undeterminate",
                                      attrs: {
                                        d: "M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "sort-criterion",
                        class: [
                          "wide-" + (3 - _vm.hasDescription - _vm.hasTaxonomy),
                          {
                            "sort-selected": _vm.sortKey == "target",
                            "sort-down": _vm.sortOrder < 0,
                          },
                        ],
                      },
                      [
                        _c("span", { staticClass: "th-label" }, [
                          _vm._v("Target"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ResultColumnMenu",
                          _vm._b(
                            {
                              on: {
                                sort: function ($event) {
                                  return _vm.changeSortMode("target")
                                },
                                filter: (v) => _vm.onColumnFilter("target", v),
                              },
                            },
                            "ResultColumnMenu",
                            _vm.columnMenuProps("target"),
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasDescription
                      ? _c(
                          "th",
                          {
                            staticClass: "sort-criterion has-help",
                            class: {
                              "sort-selected": _vm.sortKey == "desc",
                              "sort-down": _vm.sortOrder < 0,
                            },
                          },
                          [
                            _c("span", { staticClass: "th-label" }, [
                              _vm._v("Description"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { "open-delay": "300", top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              { staticClass: "th-help" },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$MDI.HelpCircleOutline
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2458809382
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "Triple click to select whole cell (for very long identifiers)"
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ResultColumnMenu",
                              _vm._b(
                                {
                                  on: {
                                    sort: function ($event) {
                                      return _vm.changeSortMode("desc")
                                    },
                                    filter: (v) =>
                                      _vm.onColumnFilter("desc", v),
                                  },
                                },
                                "ResultColumnMenu",
                                _vm.columnMenuProps("desc"),
                                false
                              )
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasTaxonomy
                      ? _c(
                          "th",
                          {
                            staticClass: "sort-criterion",
                            class: {
                              "sort-selected": _vm.sortKey == "tax",
                              "sort-down": _vm.sortOrder < 0,
                            },
                          },
                          [
                            _c("span", { staticClass: "th-label" }, [
                              _vm._v("Scientific Name"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ResultColumnMenu",
                              _vm._b(
                                {
                                  on: {
                                    sort: function ($event) {
                                      return _vm.changeSortMode("tax")
                                    },
                                    filter: (v) => _vm.onColumnFilter("tax", v),
                                  },
                                },
                                "ResultColumnMenu",
                                _vm.columnMenuProps("tax"),
                                false
                              )
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "thin sort-criterion default-down",
                        class: {
                          "sort-selected": this.sortKey == "idf",
                          "sort-down": this.sortOrder < 0,
                        },
                        attrs: { title: "IDF-score" },
                      },
                      [
                        _c("span", { staticClass: "th-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$vuetify.breakpoint.mdAndDown
                                ? "IDF"
                                : "IDF-score"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ResultColumnMenu",
                          _vm._b(
                            {
                              on: {
                                sort: function ($event) {
                                  return _vm.changeSortMode("idf")
                                },
                                filter: (v) => _vm.onColumnFilter("idf", v),
                              },
                            },
                            "ResultColumnMenu",
                            _vm.columnMenuProps("idf"),
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "thin sort-criterion",
                        class: {
                          "sort-selected": this.sortKey == "rmsd",
                          "sort-down": this.sortOrder < 0,
                        },
                        attrs: { title: "RMSD" },
                      },
                      [
                        _c("span", { staticClass: "th-label" }, [
                          _vm._v("RMSD"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ResultColumnMenu",
                          _vm._b(
                            {
                              on: {
                                sort: function ($event) {
                                  return _vm.changeSortMode("rmsd")
                                },
                                filter: (v) => _vm.onColumnFilter("rmsd", v),
                              },
                            },
                            "ResultColumnMenu",
                            _vm.columnMenuProps("rmsd"),
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "thin sort-criterion default-down",
                        class: {
                          "sort-selected": this.sortKey == "node",
                          "sort-down": this.sortOrder < 0,
                        },
                        attrs: { title: "Node count" },
                      },
                      [
                        _c("span", { staticClass: "th-label" }, [
                          _vm._v("Nodes"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ResultColumnMenu",
                          _vm._b(
                            {
                              on: {
                                sort: function ($event) {
                                  return _vm.changeSortMode("node")
                                },
                                filter: (v) => _vm.onColumnFilter("node", v),
                              },
                            },
                            "ResultColumnMenu",
                            _vm.columnMenuProps("node"),
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$vuetify.breakpoint.lgAndDown
                                ? "Residues"
                                : "Matched residues"
                            ) +
                            "\n                    "
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { "open-delay": "300", top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                              float: "right",
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$MDI.HelpCircleOutline)
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2277199409
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "The position of the aligned motif residues in the target"
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "alignment-action thin" }, [
                      _vm._v("Structure"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(
                    _vm.sortedSplittedIndices,
                    function ([dbIdx, groupidx], sortIdx) {
                      return _vm._l(
                        _vm.hits.results[dbIdx].alignments[groupidx],
                        function (item, index) {
                          return _c(
                            "tr",
                            {
                              key: `${dbIdx}-${groupidx}-${index}`,
                              class: ["hit", { active: item.active }],
                              style: {
                                "--active-color": _vm.idxToColor[dbIdx],
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.$vuetify.breakpoint.smAndDown
                                    ? _vm.onCheckboxClick(sortIdx, $event)
                                    : () => {}
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "entry-checkbox",
                                  attrs: {
                                    id: "top." + dbIdx + "#" + groupidx,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-input--selection-controls__input custom-checkbox",
                                      staticStyle: {
                                        "user-select": "none",
                                        "-webkit-user-select": "none",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: "calc(50% - 12px)",
                                        left: "6px",
                                      },
                                      attrs: {
                                        title: _vm.multipleSelectionEnabled
                                          ? "click to select, shift-click for multiple selection"
                                          : "click to toggle the selection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onCheckboxClick(
                                            sortIdx,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "v-icon notranslate",
                                          class: {
                                            "theme--light":
                                              !_vm.$vuetify.theme.dark,
                                            "theme--dark":
                                              _vm.$vuetify.theme.dark,
                                          },
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "v-icon__svg",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 24 24",
                                                role: "img",
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                staticClass: "unchecked",
                                                attrs: {
                                                  d: "M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                staticClass: "checked",
                                                attrs: {
                                                  d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "border-td",
                                    attrs: {
                                      "data-text": _vm.idxToDb[dbIdx]
                                        .replaceAll(/_folddisco$/g, "")
                                        .toUpperCase(),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return (() =>
                                          _vm.$emit(
                                            "jumpTo",
                                            Number(dbIdx)
                                          )).apply(null, arguments)
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "long",
                                  style: {
                                    "border-color": "var(--active-color)",
                                  },
                                  attrs: { "data-label": "Target" },
                                },
                                [
                                  _c("a", {
                                    staticClass: "anchor",
                                    staticStyle: {
                                      position: "absolute",
                                      top: "0",
                                    },
                                    attrs: { id: item.id },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  Array.isArray(item.href)
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            color: "#2196f3",
                                          },
                                          attrs: {
                                            rel: "noopener",
                                            title: item.target,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.emitForwardDropdown(
                                                $event,
                                                item.href
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.targetname))]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.href,
                                            target: "_blank",
                                            rel: "noopener",
                                            title: item.target,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.targetname))]
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasDescription
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "long",
                                      attrs: { "data-label": "Description" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: item.description
                                              ? item.description
                                              : "-",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.description
                                                ? item.description
                                                : "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasTaxonomy
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "long",
                                      attrs: { "data-label": "Taxonomy" },
                                    },
                                    [
                                      item.taxName
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?mode=Info&id=" +
                                                  item.taxId,
                                                target: "_blank",
                                                rel: "noopener",
                                                title: item.taxName
                                                  ? item.taxName
                                                  : "-",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.taxName))]
                                          )
                                        : _c("span", [_vm._v("-")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "thin",
                                  attrs: { "data-label": "idf-score" },
                                },
                                [_vm._v(_vm._s(item.idfscore))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "thin",
                                  attrs: { "data-label": "RMSD" },
                                },
                                [_vm._v(_vm._s(item.rmsd))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "thin",
                                  attrs: { "data-label": "Node count" },
                                },
                                [_vm._v(_vm._s(item.nodecount))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { "data-label": "Matched residues" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "matched-residues-text",
                                      attrs: { title: item.targetresidues },
                                    },
                                    [_vm._v(_vm._s(item.targetresidues))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "alignment-action thin",
                                  attrs: { rowspan: 1 },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "v-btn v-btn--icon v-btn--round v-btn--text v-size--default",
                                      class: {
                                        "v-btn--outlined":
                                          _vm.alignment &&
                                          item.target == _vm.alignment.target,
                                        "theme--dark": _vm.$vuetify.theme.dark,
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.showAlignment(
                                            dbIdx,
                                            groupidx,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "v-btn__content" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "v-icon notranslate theme--dark",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "v-icon__svg",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 24 24",
                                                    role: "img",
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      )
                    }
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tbody", [
      _c("tr", {
        staticStyle: { height: "8px" },
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }